import '../common/declaration';
import {registerTurnstileForCustomSubmitForm} from "../../cloudflare_turnstile/cloudflareTurnstile";
import {notNull} from "../../assert";

export function initializeContactFormV2(cmsModuleId: string|number) {
    const moduleElement = notNull(document.querySelector<HTMLElement>(`#contact_form${cmsModuleId}`));
    const contactForm = notNull(moduleElement.querySelector<HTMLFormElement>('form'));

    const turnstileForm = registerTurnstileForCustomSubmitForm(contactForm);

    contactForm.addEventListener('submit', function(event) {
        event.preventDefault();

        if (! turnstileForm.hasResponse()) {
            return;
        }

        KunzmannModulScripts.reloadModule(contactForm);
        moduleElement.scrollIntoView({behavior: "smooth"});
    });

    setTimeout(function() {
        const formErrors = contactForm.querySelectorAll<HTMLSpanElement>('span.error_message');
        for (const message of formErrors) {
            message.style.opacity = '0';
        }
    }, 3000);
}
